import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import { JVDropdown } from "../../../../shared/JVDropdown";
import { JVInput } from "../../../../shared/JVInput";
import { Fetch } from "../../../../shared/Fetch";
import { useEffect, useState } from "react";
import { IQuestion } from "./Table";

interface IProps {
    open: boolean,
    singleData: IQuestion,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

const schema = yup.object({
    question: yup.string().required("Question is required*"),
    question_Status: yup.boolean().required("Question Status is required*").typeError("Question Status is required*"),
});

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IQuestion>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onHide = () => {
        props.reloadTable();
        props.hideDialog();
    }

    const onSubmit = async (data: IQuestion) => {
        setLoading(true);
        const method = props.singleData.question_ID ? "PUT" : "POST";
        const message = props.singleData.question_ID ? "Updated Successfully" : "Added Successfully";
        const url = props.singleData.question ? "updateQuestion" : "addQuestion";

        if (props.singleData.question_ID) {
            delete data.added_On;
            delete data.added_By;
            delete data.updated_On;
            delete data.updated_By;
        };

        const response = await Fetch(("CarnivalTraining/" + url), method, data, null, props.toast);

        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            onHide();
        } else setLoading(false);
    }

    const header = () => {
        return <p></p>
    }

    useEffect(() => {
        if (props.open) {
            reset(props.singleData);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Add/Edit Category" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Question" control={control} name="question" error={errors.question?.message} />
                <JVDropdown required label="Status" control={control} name="question_Status" options={[{ name: "-- SELECT --", value: null }, { name: "Active", value: true }, { name: "Inactive", value: false }]} optionLabel="name" optionValue="value" placeholder="Select Status" error={errors.question_Status?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}